var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 6.13575H3.10347L7.91534 1.50438C8.00217 1.42366 8.07142 1.32711 8.11907 1.22036C8.16671 1.1136 8.19179 0.998785 8.19284 0.882603C8.19389 0.766421 8.17089 0.651202 8.12518 0.543667C8.07947 0.436133 8.01196 0.338437 7.92661 0.256281C7.84125 0.174125 7.73975 0.109154 7.62802 0.065158C7.51629 0.0211623 7.39659 -0.000976552 7.27588 3.30374e-05C7.15517 0.00104263 7.03587 0.0251806 6.92496 0.0710385C6.81405 0.116896 6.71373 0.183556 6.62987 0.267127L0.266172 6.39213C0.0957422 6.55621 0 6.77873 0 7.01075C0 7.24277 0.0957422 7.46529 0.266172 7.62938L6.62987 13.7544C6.80133 13.9138 7.03097 14.002 7.26933 14C7.50769 13.998 7.73571 13.906 7.90426 13.7437C8.07282 13.5815 8.16843 13.362 8.1705 13.1326C8.17257 12.9032 8.08094 12.6822 7.91534 12.5171L3.10347 7.88575H19.0909C19.332 7.88575 19.5632 7.79356 19.7337 7.62947C19.9042 7.46538 20 7.24282 20 7.01075C20 6.77869 19.9042 6.55613 19.7337 6.39203C19.5632 6.22794 19.332 6.13575 19.0909 6.13575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.ae6b97df59f796d4f044ab4d9879a000.svg";
export { ForwardRef as ReactComponent };